export default "__VITE_ASSET__CjAWIH87__"